module.exports = __webpack_public_path__ + "static/media/simulator-background.eecc65b3.png";